import ISIConfig from '../copied/models/ISIConfig';
import useFetchHelpCenter from './fetch/useFetchHelpCenter';

export default function useImportantSafetyInformation() {
  const { data: helpCenter } = useFetchHelpCenter();
  const isiConfig = helpCenter?.isi_block as ISIConfig;

  if (isiConfig?.copy_from_intake) {
    return isiConfig?.header_resources_block;
  }

  return isiConfig?.isi_resources_block;
}
